<template>
  <vx-card title="Featured Categories">
    <draggable :list="data.itemList" :group="{name:'tags',  pull:'clone', put:false }" class="p-2 cursor-move mb-5" @end="saveChanges">
      <vs-chip
        v-for="(listItem, index) in data.itemList"
        :key="index" closable
        @click="remove(index)"
      >
        <vs-avatar :src="listItem.iconUrl" :style="{ backgroundColor: listItem.backgroundColor }" />
        {{ listItem.nameId }}
      </vs-chip>
    </draggable>
    <select-category class="pt-5" label="Click to add category" @change="selectCategoryChange" />
  </vx-card>
</template>

<script>
  import draggable from 'vuedraggable'

  export default {
    computed: {
      data() {
        return this.$store.state.page.data.homeFeaturedCategories || { itemList: [] }
      }
    },
    components: { draggable },
    methods: {
      selectCategoryChange(val) {
        this.data.itemList.push(val)
        this.saveChanges()
      },
      saveChanges () {
        this.$store.dispatch('page/set', this.data)
      },
      remove (index) {
        this.data.itemList.splice(index, 1)
        this.saveChanges()
      }
    }
  }
</script>
